import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = { class: "gutter line-number" }
const _hoisted_3 = ["pseudo-content"]
const _hoisted_4 = ["pseudo-content"]
const _hoisted_5 = {
  key: 0,
  class: "execution-log__node-badge"
}
const _hoisted_6 = ["pseudo-content"]
const _hoisted_7 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_socket = _resolveComponent("ui-socket")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["execution-log__line", { 'execution-log__line--selected': _ctx.selected }]),
    "data-test-id": "log-entry-flex-execution-log-line",
    title: _ctx.title
  }, [
    (_ctx.displayGutter)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["execution-log__gutter", {
        'execution-log__gutter--slim': _ctx.timestamps && !_ctx.command,
      }]),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onLineSelect && _ctx.onLineSelect(...args)))
        }, [
          _createElementVNode("span", _hoisted_2, [
            _createElementVNode("span", {
              class: "execution-log_gutter-entry",
              "pseudo-content": _ctx.timestamps ? _ctx.formatTime() : ''
            }, null, 8, _hoisted_3),
            (_ctx.command)
              ? (_openBlock(), _createElementBlock("i", {
                  key: 0,
                  class: _normalizeClass(["rdicon icon-small", [_ctx.logEntry.stepType]])
                }, null, 2))
              : _createCommentVNode("", true),
            _createElementVNode("span", {
              class: "execution-log_gutter-entry",
              "pseudo-content": _ctx.command ? _ctx.logEntry.stepLabel : ''
            }, null, 8, _hoisted_4)
          ])
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["execution-log__content", [
        `execution-log__content--level-${_ctx.logEntry.level.toLowerCase()}`,
        {
          'execution-log__content--html': _ctx.logEntry.logHtml,
        },
      ]])
    }, [
      _createVNode(_component_ui_socket, {
        section: "execution-log-line",
        location: "badges",
        "event-bus": _ctx.eventBus,
        "socket-data": {
          prevEntry: _ctx.prevEntry,
          logEntry: _ctx.logEntry,
        }
      }, null, 8, ["event-bus", "socket-data"]),
      (_ctx.displayNodeBadge)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
            _cache[1] || (_cache[1] = _createElementVNode("i", { class: "fas fa-hdd" }, null, -1)),
            _createElementVNode("span", {
              "pseudo-content": _ctx.logEntry.node
            }, null, 8, _hoisted_6)
          ]))
        : _createCommentVNode("", true),
      (_ctx.logEntry.logHtml)
        ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: _normalizeClass(["execution-log__content-text", { 'execution-log__content-text--overflow': !_ctx.lineWrap }]),
            "data-test-id": "log-entry-content-text",
            innerHTML: _ctx.logEntry.logHtml
          }, null, 10, _hoisted_7))
        : _createCommentVNode("", true),
      (!_ctx.logEntry.logHtml)
        ? (_openBlock(), _createElementBlock("span", {
            key: 2,
            class: _normalizeClass(["execution-log__content-text", { 'execution-log__content-text--overflow': !_ctx.lineWrap }]),
            "data-test-id": "log-entry-content-text"
          }, _toDisplayString(_ctx.logEntry.log), 3))
        : _createCommentVNode("", true)
    ], 2)
  ], 10, _hoisted_1))
}